import React from 'react';
import {Collapse} from "@blueprintjs/core";
import DanhSachBangChung from './DanhSachBangChung.jsx';
import {Text, TextMessage} from 'components/tt-forms/common';

class ThongTinDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps})
  }

  render() {
    let Item = this.props;
    return (
      <div  className="box-forward wrap-block">
        <div className="container-box">
            <div className="group-box">
              <Collapse isOpen={this.props.isOpen}>
                <div className="title">
                  <div className="rows">
                      <div className="col-12">
                        <h3 className='title-14'>{this.props.title}</h3>
                      </div>
                  </div>
                </div>
                <div className="items-form">
                  <div className="rows mb10">
                    <Text className="col-input" label="Loại đơn thư:" value={Item.loaiDonText}/>
                    {
                      Item.loaiDon == 'DON_KHIEU_NAI' || Item.loaiDon == "DON_TO_CAO" ? (
                        <Text className='col-input' label={`Loại đối tượng${Item.loaiDon == "DON_TO_CAO" ? ' bị tố cáo' : ''}:`} value={Item.loaiDoiTuongInfo ? Item.loaiDoiTuongInfo.ten : ''}/>
                        ) : null
                    }
                    <Text className="col-input" label="Lĩnh vực:" value={(Item && Item.linhVucDonThuDon) ? Item.linhVucDonThuDon.ten : ''}/>
                    <div className={`col-input ${Item && Item.linhVucDonThuChiTietDon ? '' : 'hidden'}`}>
                      <label className="pt-label">
                        <span className="val-title-bold">Lĩnh vực chi tiết:</span>
                      </label>
                      <p className={(Item && Item.chiTietLinhVucDonThuChiTietDon) ? 'val-content arrow-to-dispute' : 'val-content'}>{(Item && Item.linhVucDonThuChiTietDon) ? Item.linhVucDonThuChiTietDon.ten : ''}</p>
                    </div>
                    <Text className={`col-input ${Item && Item.chiTietLinhVucDonThuChiTietDon ? '' : 'hidden'}`} label="&nbsp;" value={(Item && Item.chiTietLinhVucDonThuChiTietDon) ? Item.chiTietLinhVucDonThuChiTietDon.ten : ''}/>
                  </div>
                </div>
              </Collapse>
               <div className="items-form">
                  <div className="rows mb10">
                    <TextMessage className="col-12" label="Tóm tắt nội dung đơn thư:" value={(Item && Item.noiDung) ? Item.noiDung : ''}/>
                  </div>
               </div>
              <Collapse isOpen={this.props.isOpen}>
                <div>
                  <Text className="col-input mb10" label="Loại vụ việc:" value={(Item && Item.loaiVuViecInfo) ? Item.loaiVuViecInfo.ten : ''}/>
                  <DanhSachBangChung listTLBC={this.props.listTLBC} checkTDGS={this.props.checkTDGS} listTaiLieuBangChung={this.props.listTaiLieuBangChung}/>
                </div>
              </Collapse>
            </div>
        </div>
      </div>
    );
  }
}

export default ThongTinDon;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ThongTinDon.jsx